import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Organization + WebSite are baked into public/index.html for raw-HTML crawlers.
const STATIC_IDS = ["/#organization", "/#website"];

export default function SchemaLd({ type, ekey }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    if (!ekey) return;
    const base = typeof window !== "undefined" ? window.location.origin : "";
    api.get("/seo/schema", { params: { type, key: ekey, base } })
      .then((r) => setItems((r.data.items || []).filter((o) => !STATIC_IDS.some((s) => (o["@id"] || "").endsWith(s)))))
      .catch(() => setItems(null));
  }, [type, ekey]);
  if (!items || !items.length) return null;
  return (
    <Helmet>
      {items.map((o, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(o)}</script>
      ))}
    </Helmet>
  );
}
